module.exports = __webpack_public_path__ + "images/tour/progress_lesson_box-db79c620229e0cca164791c6992a4ede.gif";